<template>
    <div :class="classNames">
        <el-form ref="ruleForm" :rules="rules" :model="commentForm" label-position="top" label-width="100px">
            <el-form-item label="推广员昵称/手机号" prop="talent_id">
                <el-select v-model="commentForm.talent_id" filterable remote :remote-method="remoteMethod" @visible-change="visibleChange" :loading="searchLoading" :disabled="IdDisabled" :popper-class="classNames+ '_select'" class="el-select-width">
                <el-option v-for="(item, index) in talentlist[type]" :label="item.name" :value="item.id" :key="item.hidden? item.id + item.id: item.id">
                    <p v-if="!item.hidden" class="has-child">
                        <span :class="classNames+ '-name'" :style="{'max-width': !item.phone? '192px': ''}">{{item.name}}</span>
                        <span v-if="item.phone">({{item.phone}})</span>
                    </p>
                    <p v-else></p>
                </el-option>
                <el-option label="" :value="-1" :disabled="true" v-if="talentlist[type].length">
                    <p style="height: 30px;text-align:center" v-if="titleObj.page < Math.ceil(talentlist.count / titleObj.limit)"><span style="margin-right: 6px">加载中</span><i class="el-icon-loading"></i></p>
                    <template v-else>
                        <p style="height: 30px;text-align:center" v-if="!loading"><span style="margin-right: 6px">已经到底啦～～</span></p>
                    </template>
                </el-option>
                <el-option label="" :value="-999" :disabled="true" v-else>
                    <span>暂无数据</span>
                </el-option>
            </el-select>
            </el-form-item>
            <el-form-item label="分佣比例(0%~100%)" prop="rate">
                <div style="display:flex">
                    <el-input placeholder="分佣比例" v-model="commentForm.rate" @input="handleRatio"></el-input><span style="margin-left:12px">%</span>
                </div>
            </el-form-item>
            <el-form-item label="关联课程(选择课程时已对该推广用户设置过的课程不能再次选择)" prop="product_ids">
                <el-button type="primary" @click="addClass">添加课程</el-button>
                <template>
                    <el-table :data="classList.data" v-if="classList.data.length">
                        <el-table-column label='标题'>
                            <template slot-scope="scope">
                                <span>{{scope.row.title}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label='操作' width="100px">
                            <template slot-scope="scope">
                                <span @click="deleteClass(scope.row)" style="cursor:pointer">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <Pagination @change="changeSize" :total="classList.count"  v-model="productIdsParams.page" v-if="Math.ceil(classList.count / productIdsParams.limit) > 1" style="line-height: normal;padding-bottom: 0"></Pagination>
                </template>
            </el-form-item>
         </el-form>
        <gettingList  :requestNameObj="{name: 'productSelect', data: 'list'}" v-model="gettingFlag"  @getClassList="getClassList" :idsList="commentForm.product_ids" :classAllParamsList="classAllList" ref="gettingList"></gettingList>
        <div style="display: flex;justify-content: flex-end">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="sure">确 定</el-button>
        </div>
    </div>
</template>
<script>
    import { mapActions } from 'vuex'
    import gettingList from './list.vue'
    export default {
       data() {
           return {
               classNames: 'opearateSharePromotion',
                titleObj: {
                    page: 1,
                    limit: 10,
                    search:''
                },
                searchLoading: false,
                loading: false,
                commentForm: {
                    talent_id: '',
                    rate: '',
                    product_ids: []
                },
                rules: {
                    talent_id: [
                        { 
                            required: true,
                            message: '请输入推广员昵称/手机号', 
                            trigger: 'change'
                        }
                    ],
                    rate: [
                        { 
                            required: true,
                            message: '请输入分佣比例', 
                            trigger: 'blur'
                        }
                    ],
                    product_ids: [
                        { type: 'array', required: true, message: '请至少选择一个课程', trigger: 'change' }
                    ] 
                },
                talentlist: {
                    count: 0,
                    data: []
                },
                type: 'data',
                gettingFlag: false,
                productIdsParams: {
                    page: 1,
                    limit: 10,
                },
                classList: {
                    data: [],
                    count: 0
                },
                classAllList: []
           }
        },
        components: {
            gettingList
        },
        created() {
            this.getTalentlist()
            if(this.$route.params.id) {
                this.getUserAppoint(this.$route.params.id)
                this.getAppointProduct(this.$route.params.id)
            }
            this.$nextTick(() => {
                let dom = document.querySelector(`.${this.classNames + '_select'} .el-scrollbar__wrap`)
                dom.addEventListener('scroll',this.scrollLoad , false)
            })
            this.$watch(() => this.classAllList, (news)=> {
                this.commentForm.product_ids = news.map(item => item.id)
                console.log(this.commentForm.product_ids, '===')
            })
        },
        computed: {
            IdDisabled() {
                return this.$route.params.id ? true: false
            }
        },
        methods: {
            ...mapActions('help', ['appointProduct', 'searchtalent', 'addappoint', 'userAppoint', 'editappoint']),
            async getTalentlist(flag) {
                let res = await this.searchtalent(this.titleObj)
                this.loading = false
                this.searchLoading = false
                if(flag) {
                    this.talentlist = {
                        [this.type]: [...this.talentlist[this.type], ...res.data],
                        count: res.count
                    }
                } else {
                    this.talentlist = {
                        count: res.count || 0,
                        [this.type]: res.data || []
                    }
                }
            },
            remoteMethod(value) {
                this.titleObj.search = value
                this.titleObj.page =1
                this.searchLoading = true
                let dom = document.querySelector(`.${this.classNames + '_select'} .el-scrollbar__wrap`)
                dom.scrollTop = 0
                this.talentlist.data = []
                this.getTalentlist()
            },
            handleRatio() {
                this.commentForm.rate = this.commentForm.rate.replace(/[^0-9]/g, '')
                if (this.commentForm.rate < 0 || this.commentForm.rate > 100) {
                    this.commentForm.rate = this.commentForm.rate.slice(0, this.commentForm.rate.length - 1)
                }
            },
            visibleChange(value) {
                if(!value && this.titleObj.search) {
                    this.titleObj.search= ''
                    this.getTalentlist()
                }
            },
            scrollLoad(e) {
                const dom = e.target
                let clientHeight = dom.clientHeight
                let scrollHeight = dom.scrollHeight
                if(clientHeight + e.target.scrollTop + 10 >= scrollHeight && !this.loading && this.titleObj.page < Math.ceil(this.talentlist.count / this.titleObj.limit)) {
                    this.loading = true
                    this.titleObj.page++
                    this.getTalentlist(true)
                }
            },
            addClass() {
                this.gettingFlag = true
            },
            // sureClass(list) {
            //     this.commentForm.product_ids = list
            // },
            async getAppointProduct(id) {
                let res = await this.appointProduct({params: {id}})
                this.classAllList = res
                this.getTableList()
            },
            getTableList() {
                this.classList = {
                    data: this.classAllList.slice((this.productIdsParams.page - 1) * this.productIdsParams.limit, this.productIdsParams.page * this.productIdsParams.limit),
                    count: this.classAllList.length
                }
            },
            async getUserAppoint(id) {
                let res = await this.userAppoint({
                    params: {id}
                })
                let obj = { name: res.talent_name,id: res.talent_id,phone: res.talent_phone }
                this.talentlist.data.splice(0,0, obj)
                this.commentForm.rate = res.rate
                this.commentForm.talent_id = res.talent_id
            },
            getClassList(list) {
                this.classAllList = list
                this.productIdsParams.page = 1
                this.getTableList()
            },
            changeSize(size) {
                this.productIdsParams.page = size
                this.getTableList()
            },
            deleteClass(row) {
                let index = this.classAllList.findIndex(item => item.id === row.id)
                this.classAllList.splice(index, 1)
                if(this.classAllList.length % this.productIdsParams.limit == 0){
                    this.productIdsParams.page--
                }
                this.getTableList()
            },
            cancel() {
                this.$router.go(-1)
            },
            sure() {
                this.$refs.ruleForm.validate(async (valid) => {
                    if (valid) {
                        let params = {...this.commentForm}
                        if(this.$route.params.id) {
                            params.id= this.$route.params.id
                            params.type= 'all'
                            await this.editappoint(params)
                        } else {
                            await this.addappoint(params)
                        }
                        this.$router.go(-1)
                    }
                })
            }
       },
        beforeDestroy() {
            let dom = document.querySelector(`.${this.classNames + '_select'} .el-scrollbar__wrap`)
            dom && dom.removeEventListener('scroll',this.scrollLoad , false)
        },
   }
</script>
<style lang="less" scoped>
    @classNames: opearateSharePromotion;
    .@{classNames} {
        max-width: 660px;
        .el-select-width {
            width: 100%;
        }
    }
</style>
